import { Menu as MaterialMenu, MenuItem } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { deleteCachedSearch } from "src/searchCache/actions";
import QuiqButton from "src/shared/QuiqButton";
import {
  expireOktaSession,
  ExpireOktaSessionActionType,
  expireSession,
  ExpireSessionActionType
} from "../login/actions";
import { getUserId } from "../login/selector";
import { getTokenType } from "../route/LocalStorage";
import { State } from "../state";
import ChevronDown from "./chevron_down.svg";
import "./Menu.scss";

interface MenuProps extends RouteComponentProps<any>, React.Props<any> {
  userId: string;
  expireSession: ExpireSessionActionType;
  expireOktaSession: ExpireOktaSessionActionType;
  deleteCachedSearchFunc: typeof deleteCachedSearch | any;
}

interface MenuState {
  open: boolean;
  anchorEl: HTMLElement | null;
}

export class Menu extends React.Component<MenuProps, MenuState> {
  constructor(props: MenuProps) {
    super(props);
    this.state = { open: false, anchorEl: null };
    this.signOut = this.signOut.bind(this);
  }

  public openMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({
      open: this.state.open ? false : true,
      anchorEl: event.currentTarget
    });
  };

  public closeMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: false, anchorEl: null });
  };

  public async signOut() {
    if (getTokenType() === "jwt") {
      await this.props.expireOktaSession();
      this.props.deleteCachedSearchFunc({});
    } else {
      await this.props.expireSession();
      this.props.deleteCachedSearchFunc({});
      this.props.history.push("/login");
    }
  }

  public returnShortedUserId() {
    const { userId } = this.props;
    let shortedUserId = userId.replace(/[^a-zA-Z0-9 ]/g, "");
    const wordsToRemoveFromUserId = [
      "dev",
      "qa",
      "staging",
      "prod",
      "admin",
      "example",
      "com",
      "se",
      "QS"
    ];

    for (const i of wordsToRemoveFromUserId) {
      shortedUserId = shortedUserId.replace(`${i}`, "");
    }

    return shortedUserId.substring(0, 2);
  }

  public render() {
    return (
      <div className="Menu">
        <QuiqButton
          className="Menu__link"
          onClick={this.openMenu}
          variant="text"
        >
          <div className="Menu__link__user-icon-outer">
            <div className="Menu__link__user-icon">
              {this.returnShortedUserId()}
            </div>
          </div>
          <span className="Menu__link__username">{this.props.userId}</span>
          <img src={ChevronDown} />
        </QuiqButton>
        <MaterialMenu
          className="Menu__container"
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onClose={this.closeMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          getContentAnchorEl={null}
        >
          <MenuItem className="Menu__actions__signOut" onClick={this.signOut}>
            Sign Out
          </MenuItem>
        </MaterialMenu>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  userId: getUserId(state)
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      expireSession: expireSession.action,
      expireOktaSession: expireOktaSession.action,
      deleteCachedSearchFunc: deleteCachedSearch
    }
  )(Menu)
);



// WEBPACK FOOTER //
// ./src/topNav/Menu.tsx